import React, { useEffect, useRef, useState } from "react";
import pdf from '../assets/Resume.pdf'
import { Link } from "react-router-dom";
import "../Styles/ResumeStyle.css";
import img1 from '../assets/avatar.jpg'
import { Col, Row, Container, Button,Image } from "react-bootstrap";

const Resume = () => {
  const[data,setData]=useState("more")
      const [loading, setLoading] = useState(false);

      const handleDownload = () => {
        setLoading(true);
        // Simulating download process for 2 seconds
        setTimeout(() => {
          setLoading(false);
          // Simulate download link click
          const link = document.createElement("a");
          link.href = pdf; // Assuming pdf is defined somewhere
          link.download = "Resume.pdf";
          link.click();
        }, 2000);
      };
  return (
    <div className="resumeparent">
      <div className="d-flex justify-content-center  mt-5 mb-5">
        <h3 style={{ color: "var(--primary-color)" }} className="mx-auto">
          Resume
        </h3>
        <Link to={"/"} className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            className="cursor-pointer me-4"
            style={{ cursor: "pointer" }}
          >
            <g fill="var(--text-color)" fill-rule="evenodd" clip-rule="evenodd">
              <path d="M5.47 5.47a.75.75 0 0 1 1.06 0l12 12a.75.75 0 1 1-1.06 1.06l-12-12a.75.75 0 0 1 0-1.06" />
              <path d="M18.53 5.47a.75.75 0 0 1 0 1.06l-12 12a.75.75 0 0 1-1.06-1.06l12-12a.75.75 0 0 1 1.06 0" />
            </g>
          </svg>
        </Link>
      </div>
      <Row className="me-5 g-5">
        <Col sm={12} lg={2} className="d-flex flex-column  sidepanelparent ">
          <div
            className="text-white sidepanel mx-auto rounded-1 py-4"
            style={{ width: "20rem" }}
          >
            <Image src={img1} roundedCircle width={50} height={50} />
            <p>P V D SIVA KRISHNA</p>
            <p>BIRTHDAY: 25/07/2003</p>
            <p>
              WEBSITE:<a href="#"></a>
            </p>
            <p>EMAIL:pillashivakrisna6@gmail.com</p>
            <p>PHONE: 7386898469</p>
            <p>Location: Kakinada,Andhra Pradesh</p>
            <Button
              className="btn btn-success"
              onClick={handleDownload}
              disabled={loading}
            >
              {loading ? "Downloading..." : "Download CV"}
            </Button>
            <div className="lang  shadow-md bg-dark rounded mt-4 text-center">
              <p className="text-success fw-bold">Interests</p>
              <p>Problem Solving</p>
              <p>Playing Online Games</p>
            </div>
          </div>
        </Col>

        <Col sm={12} lg={10} className="con2">
          <Container className="me-5" style={{}}>
            <Col lg={8} md={12} className="rounded-3 containerResume">
              <div style={{ color: "white" }} className="">
                <h4 className="py-4 px-4 ms-4">Hello I am Shiva!</h4>

                <p className="px-5">
                  I am a dedicated computer science and engineering student at
                  Centurion University of Technology and Management, currently
                  enrolled in the program from 2021 to 2025. My academic journey
                  has equipped me with a solid understanding of various
                  programming languages, including Java, Python, and JavaScript.
                  Alongside my proficiency in AWS Cloud Practitioner and
                  solution architecture, I have developed strong problem-solving
                  skills and a sound knowledge of data structures. My expertise
                  extends to web development frameworks such as React, Tailwind
                  CSS, and Bootstrap, allowing me to create dynamic and
                  responsive applications. This diverse skill set reflects my
                  commitment to staying at the forefront of technology and my
                  passion for leveraging innovative solutions in the field of
                  computer science.
                </p>
                <Link to={"/Contact"}>
                  <Button
                    style={{ background: "var(--primary-color)" }}
                    className="border-0 ms-5 mb-4"
                  >
                    Hire me
                  </Button>
                </Link>
                <div className="arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    title="Please Scroll Inside Box"
                    className="float-end me-4"
                  >
                    <path
                      fill="white"
                      d="M11.5 5v12.079l-5.792-5.792L5 12l7 7l7-7l-.708-.713l-5.792 5.792V5z"
                    />
                  </svg>
                </div>
              </div>
              <div className="ms-5 mt-3">
                <Row className="mx-auto " style={{ marginBottom: "15rem" }}>
                  <Col sm={12} md={12} lg={6}>
                    <p
                      className="ms-5 "
                      style={{ color: "var(--primary-color)" }}
                    >
                      Major
                    </p>
                    <h4 className="ms-5" style={{ color: "var(--text-color)" }}>
                      Education
                    </h4>
                    <p style={{ color: "var(--text-color)" }}>Career</p>
                    <div className="edu-poll mt-5">
                      <div
                        className="careerptag"
                        style={{
                          width: ".6rem",
                          height: ".6rem",
                          borderRadius: "5rem",
                        }}
                      >
                        <div className="details ms-4">
                          <p
                            className="text-white detailcon"
                            style={{ background: "var(--primary-color)" }}
                          >
                            2009-2019
                          </p>
                          <p
                            className="bg-white rounded-1"
                            style={{ border: "3px solid var(--primary-color)" }}
                          >
                            School
                          </p>
                          <p className=" text-white detailsbio">
                            SSC Board Andhara Pradesh
                          </p>
                          <p className="detailsbio text-white">
                            Successfully qualified my Board Exams with a strong
                            A class result.
                          </p>
                        </div>
                      </div>
                      {/* section 2 */}
                      <div
                        className="careerptag"
                        style={{
                          width: ".6rem",
                          height: ".6rem",
                          borderRadius: "5rem",
                        }}
                      >
                        <div className="details ms-4">
                          <p
                            className="text-white detailcon"
                            style={{ background: "var(--primary-color)" }}
                          >
                            2019-2021
                          </p>
                          <p
                            className="bg-white rounded-1 placeptag"
                            style={{ border: "3px solid var(--primary-color)" }}
                          >
                            Senior Secondary
                          </p>
                          <p className=" text-white detailsbio">
                            Narayana Junior College
                          </p>
                          <p className="detailsbio text-white">
                            I am Successfully Completed My Senior Secondary with
                            High Score.
                          </p>
                        </div>
                      </div>
                      {/* section 3 */}
                      <div
                        className="careerptag"
                        style={{
                          width: ".6rem",
                          height: ".6rem",
                          borderRadius: "5rem",
                        }}
                      >
                        <div className="details ms-4">
                          <p
                            className="text-white detailcon"
                            style={{ background: "var(--primary-color)" }}
                          >
                            2021-2025
                          </p>
                          <p
                            className="bg-white rounded-1 placeptag"
                            style={{
                              border: "3px solid var(--primary-color)",
                              width: "13rem",
                            }}
                          >
                            Bachelor of Technology
                          </p>
                          <p className=" text-white detailsbio ">
                            Centurion University Of Techonology And Management.
                          </p>
                          <p className="detailsbio text-white">
                            Preparing my career in the field of Computer Science
                            with the base of Amazon Web Services.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={12} lg={6} className="section2">
                    <p
                      className="ms-5"
                      style={{ color: "var(--primary-color)" }}
                    >
                      Personal
                    </p>

                    <h4 className="ms-5" style={{ color: "var(--text-color)" }}>
                      Experience
                    </h4>
                    <p style={{ color: "var(--text-color)" }}>Internships</p>
                    <div className="edu-poll mt-5">
                      <div
                        className="careerptag"
                        style={{
                          width: ".6rem",
                          height: ".6rem",
                          borderRadius: "5rem",
                        }}
                      >
                        <div className="details ms-4">
                          <p
                            className="text-white detailcon"
                            style={{ background: "var(--primary-color)" }}
                          >
                            2022-2022
                          </p>
                          <p
                            className="bg-white rounded-1 placeptag p-1"
                            style={{
                              border: "3px solid var(--primary-color)",
                              width: "28rem",
                              textAlign: "start",
                            }}
                          >
                            Gram Tarang Inclusive Development Services Private
                            Limited (GTIDS) Vizag
                          </p>
                          <p
                            className="text-start fw-bold"
                            style={{
                              width: "30rem",
                              color: "var(--primary-color)",
                            }}
                          >
                            Frontend Developer (UI/UX)
                          </p>

                          <p className="detailsbio text-white">
                            Drove a project catering to 5,000 users, emphasizing
                            UI/UX excellence. Crafted user interactive designs,
                            monitored views count, and enhanced overall app
                            traffic.
                          </p>
                        </div>
                      </div>
                      <div
                        className="careerptag"
                        style={{
                          width: ".6rem",
                          height: ".6rem",
                          borderRadius: "5rem",
                        }}
                      >
                        <div className="details ms-4">
                          <p
                            className="text-white detailcon"
                            style={{ background: "var(--primary-color)" }}
                          >
                            2023-2023
                          </p>
                          <p
                            className="bg-white rounded-1 placeptag p-1 text-center"
                            style={{
                              border: "3px solid var(--primary-color)",
                              width: "15rem",
                              textAlign: "start",
                            }}
                          >
                            SAHUKAR CONSULTANCY
                          </p>
                          <p
                            className="text-start fw-bold"
                            style={{
                              width: "30rem",
                              color: "var(--primary-color)",
                            }}
                          >
                            Junior React Developer
                          </p>

                          <p className="detailsbio text-white">
                            Spearheaded a project serving 10,000 users, managing
                            a frontend of 2 million lines of code on a robust
                            cloud-based infrastructure.Pioneered UI development,
                            focusing on user interactive pages and seamless
                            client-side data transfer and rendering.
                          </p>
                        </div>
                      </div>
                      <div
                        className="careerptag"
                        style={{
                          width: ".6rem",
                          height: ".6rem",
                          borderRadius: "5rem",
                        }}
                      >
                        <div className="details ms-4">
                          <div className="d-flex justify-content-baseline gap-5">
                            <p
                              className="text-white detailcon"
                              style={{ background: "var(--primary-color) " }}
                            >
                              2024-2024
                            </p>
                          </div>
                          <p
                            className="bg-white rounded-1 placeptag p-1 text-center"
                            style={{
                              border: "3px solid var(--primary-color)",
                              width: "15rem",
                              textAlign: "start",
                            }}
                          >
                            Goo-Business
                          </p>
                          <p
                            className="text-start fw-bold"
                            style={{
                              width: "30rem",
                              color: "var(--primary-color)",
                            }}
                          >
                            Frotend Developer
                          </p>
                          <p className="detailsbio text-white">
                            Served , managing a frontend of 2 million lines of
                            code Pioneered UI development, focusing on user
                            interactive pages and seamless client-side data
                            transfer and rendering.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <div className="mb-5">
                  <h4 style={{ color: "var(--primary-color)" }}>Skills</h4>
                  <div
                    className="d-flex flex-wrap justify-content-center skillcon"
                    style={{ gap: "5rem" }}
                  >
                    <div className="skillbox  rounded-1 d-flex gap-5 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 256 218"
                        className="ms-4 mt-4"
                      >
                        <path
                          fill="#00C9DB"
                          d="M226.859 160.16h-86.308c-.97 0-2.91 0-3.88.969l-64.973 51.397c-.97.97-.97 1.94 0 2.91c0 .97.97.97 1.94.97h154.19c15.517 0 29.093-13.578 28.124-30.063c-.97-15.516-14.547-26.184-29.093-26.184"
                        />
                        <path
                          fill="#0D55FF"
                          d="M156.445 106.018c-.97-7.758-4.849-15.516-10.667-20.365L45.893 6.133c-12.607-9.698-30.062-7.758-39.76 4.849c-9.698 12.607-7.758 30.062 4.849 39.76l72.731 58.185l-72.731 58.185c-12.607 9.698-14.547 27.154-4.849 39.76c9.698 12.607 27.153 14.547 39.76 4.85l99.885-81.46c6.788-5.819 10.667-13.577 10.667-22.305z"
                        />
                        <path
                          fill="#7000F2"
                          d="M255.952 188.282c0 15.516-12.607 28.123-28.123 28.123c-15.516 0-28.123-12.607-28.123-28.123c0-15.516 12.607-28.123 28.123-28.123c15.516 0 28.123 12.607 28.123 28.123"
                        />
                      </svg>
                      <p
                        className="mt-3 skillp "
                        style={{ color: "var(--text-color)" }}
                      >
                        I can create a interactive Static/Dynamic Web Pages with
                        proper colour balance and as requested.
                      </p>
                    </div>
                    <div className="skillbox d-flex gap-5 align-baseline rounded-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 256 153"
                        className="ms-4 mt-4"
                      >
                        <path
                          fill="white"
                          d="M72.392 55.438c0 3.137.34 5.68.933 7.545a45.373 45.373 0 0 0 2.712 6.103c.424.678.593 1.356.593 1.95c0 .847-.508 1.695-1.61 2.543l-5.34 3.56c-.763.509-1.526.763-2.205.763c-.847 0-1.695-.424-2.543-1.187a26.224 26.224 0 0 1-3.051-3.984c-.848-1.44-1.696-3.052-2.628-5.001c-6.612 7.798-14.92 11.698-24.922 11.698c-7.12 0-12.8-2.035-16.954-6.103c-4.153-4.07-6.272-9.495-6.272-16.276c0-7.205 2.543-13.054 7.714-17.462c5.17-4.408 12.037-6.612 20.768-6.612c2.882 0 5.849.254 8.985.678c3.137.424 6.358 1.102 9.749 1.865V29.33c0-6.443-1.357-10.935-3.985-13.563c-2.712-2.628-7.29-3.9-13.817-3.9c-2.967 0-6.018.34-9.155 1.103c-3.136.762-6.188 1.695-9.155 2.882c-1.356.593-2.373.932-2.967 1.102c-.593.17-1.017.254-1.356.254c-1.187 0-1.78-.848-1.78-2.628v-4.154c0-1.356.17-2.373.593-2.966c.424-.594 1.187-1.187 2.374-1.78c2.967-1.526 6.527-2.798 10.68-3.815C33.908.763 38.316.255 42.978.255c10.088 0 17.463 2.288 22.21 6.866c4.662 4.577 7.036 11.528 7.036 20.853v27.464zM37.976 68.323c2.798 0 5.68-.508 8.731-1.526c3.052-1.017 5.765-2.882 8.053-5.425c1.357-1.61 2.374-3.39 2.882-5.425c.509-2.034.848-4.493.848-7.375v-3.56a70.791 70.791 0 0 0-7.799-1.441a63.874 63.874 0 0 0-7.968-.509c-5.68 0-9.833 1.102-12.63 3.391c-2.798 2.289-4.154 5.51-4.154 9.748c0 3.984 1.017 6.951 3.136 8.986c2.035 2.119 5.002 3.136 8.901 3.136m68.069 9.155c-1.526 0-2.543-.254-3.221-.848c-.678-.508-1.272-1.695-1.78-3.305L81.124 7.799c-.51-1.696-.764-2.798-.764-3.391c0-1.356.678-2.12 2.035-2.12h8.307c1.61 0 2.713.255 3.306.848c.678.509 1.187 1.696 1.695 3.306l14.241 56.117l13.224-56.117c.424-1.695.933-2.797 1.61-3.306c.679-.508 1.866-.847 3.392-.847h6.781c1.61 0 2.713.254 3.39.847c.679.509 1.272 1.696 1.611 3.306l13.394 56.795L168.01 6.442c.508-1.695 1.102-2.797 1.695-3.306c.678-.508 1.78-.847 3.306-.847h7.883c1.357 0 2.12.678 2.12 2.119c0 .424-.085.848-.17 1.356c-.085.509-.254 1.187-.593 2.12l-20.43 65.525c-.508 1.696-1.101 2.798-1.78 3.306c-.678.509-1.78.848-3.22.848h-7.29c-1.611 0-2.713-.254-3.392-.848c-.678-.593-1.271-1.695-1.61-3.39l-13.14-54.676l-13.054 54.59c-.423 1.696-.932 2.798-1.61 3.391c-.678.594-1.865.848-3.39.848zm108.927 2.289c-4.408 0-8.816-.509-13.054-1.526c-4.239-1.017-7.544-2.12-9.748-3.39c-1.357-.764-2.29-1.611-2.628-2.374a5.983 5.983 0 0 1-.509-2.374V65.78c0-1.78.678-2.628 1.95-2.628a4.8 4.8 0 0 1 1.526.255c.508.17 1.271.508 2.119.847a46.108 46.108 0 0 0 9.324 2.967a50.907 50.907 0 0 0 10.088 1.017c5.34 0 9.494-.932 12.376-2.797c2.882-1.865 4.408-4.577 4.408-8.053c0-2.373-.763-4.323-2.289-5.934c-1.526-1.61-4.408-3.051-8.561-4.408l-12.292-3.814c-6.188-1.95-10.765-4.832-13.563-8.647c-2.797-3.73-4.238-7.883-4.238-12.291c0-3.56.763-6.697 2.289-9.41c1.525-2.712 3.56-5.085 6.103-6.95c2.543-1.95 5.425-3.391 8.816-4.408c3.39-1.017 6.95-1.441 10.68-1.441c1.865 0 3.815.085 5.68.339c1.95.254 3.73.593 5.51.932c1.695.424 3.306.848 4.832 1.357c1.526.508 2.712 1.017 3.56 1.525c1.187.679 2.034 1.357 2.543 2.12c.509.678.763 1.61.763 2.797v3.984c0 1.78-.678 2.713-1.95 2.713c-.678 0-1.78-.34-3.22-1.018c-4.833-2.204-10.258-3.306-16.276-3.306c-4.832 0-8.647.763-11.275 2.374c-2.627 1.61-3.984 4.069-3.984 7.544c0 2.374.848 4.408 2.543 6.019c1.696 1.61 4.832 3.221 9.325 4.662l12.037 3.815c6.103 1.95 10.511 4.662 13.139 8.137c2.628 3.476 3.9 7.46 3.9 11.868c0 3.645-.764 6.951-2.205 9.833c-1.525 2.882-3.56 5.425-6.188 7.46c-2.628 2.119-5.764 3.645-9.409 4.747c-3.815 1.187-7.799 1.78-12.122 1.78"
                        />
                        <path
                          fill="#F90"
                          d="M230.993 120.964c-27.888 20.599-68.408 31.534-103.247 31.534c-48.827 0-92.821-18.056-126.05-48.064c-2.628-2.373-.255-5.594 2.881-3.73c35.942 20.854 80.276 33.484 126.136 33.484c30.94 0 64.932-6.442 96.212-19.666c4.662-2.12 8.646 3.052 4.068 6.442m11.614-13.224c-3.56-4.577-23.566-2.204-32.636-1.102c-2.713.34-3.137-2.034-.678-3.814c15.936-11.19 42.13-7.968 45.181-4.239c3.052 3.815-.848 30.008-15.767 42.554c-2.288 1.95-4.492.933-3.475-1.61c3.39-8.393 10.935-27.296 7.375-31.789"
                        />
                      </svg>
                      <p
                        className="mt-3 skillp "
                        style={{ color: "var(--text-color)" }}
                      >
                        Cloud Computing Skills
                      </p>
                    </div>
                    <div className="skillbox d-flex gap-5 align-baseline rounded-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 48 48"
                        className="ms-4 mt-4"
                      >
                        <g
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="4"
                        >
                          <path
                            fill="#2F88FF"
                            stroke="#000"
                            d="M38 21L43 30L38 31V37H35L29 36L28 43H13L11 32.619C7.92077 29.7028 6 25.5757 6 21C6 12.1634 13.1634 5 22 5C30.8366 5 38 12.1634 38 21Z"
                          />
                          <path
                            stroke="#fff"
                            d="M17 19C17 16.2386 19.2386 14 22 14C24.7614 14 27 16.2386 27 19C27 21.7614 24.7614 24 22 24V27"
                          />
                          <path stroke="#fff" d="M22 33V34" />
                        </g>
                      </svg>
                      <p
                        className="mt-3 skillp "
                        style={{ color: "var(--text-color)" }}
                      >
                        Problem Solving. i am succssfully solved more than 100
                        problems in Leetcode and other Coding Platforms (2023)
                      </p>
                    </div>
                    <div className="skillbox d-flex gap-5 align-baseline rounded-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 256 256"
                        className="ms-4 mt-4"
                      >
                        <path
                          fill="orange"
                          d="M176 16H80a24 24 0 0 0-24 24v176a24 24 0 0 0 24 24h96a24 24 0 0 0 24-24V40a24 24 0 0 0-24-24M80 32h96a8 8 0 0 1 8 8v8H72v-8a8 8 0 0 1 8-8m96 192H80a8 8 0 0 1-8-8v-8h112v8a8 8 0 0 1-8 8"
                        />
                      </svg>
                      <p
                        className="mt-3 skillp "
                        style={{ color: "var(--text-color)" }}
                      >
                        I can Make Resoponsive And Adaptive Mobile Designs
                      </p>
                    </div>
                  </div>
                  <Button
                    className="float-end mt-5 me-5 border border-light px-2 py-1 rounded"
                    popovertarget="mypopover"
                    style={{
                      color: "var(--text-color)",
                      background: "var(--primary-color)",
                    }}
                    onClick={() =>
                      setData(data === "more" ? "Comming soon" : "more")
                    }
                  >
                    {data} {">"}
                    {">"}
                  </Button>
                </div>
              </div>
            </Col>
          </Container>
          <iframe
            src={pdf}
            frameBorder={0}
            className="m-1 pdf1 resumepdf"
            style={{ height: "50rem" }}
            title="Resume"
          ></iframe>
        </Col>
      </Row>
    </div>
  );
};

export default Resume;
